import { MARQUEE } from "../../content/site";
import { LeafIcon } from "./Leaf";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {MARQUEE.map((m) => (
      <span key={m} className="flex items-center">
        <span className="px-8 font-display text-4xl italic text-[#1E5631] md:text-6xl">{m}</span>
        <LeafIcon className="h-7 w-5 opacity-70" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#E2DDD0] bg-[#F3EFE6] py-8">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </div>
);
